import {XIcon} from '@primer/octicons-react'
import {Heading, IconButton} from '@primer/react'

import styles from '../SimpleSelect.module.css'

type SelectHeaderProps = {
  id: string
  title?: string
  onClose: () => void
}

export const SelectHeader = ({id, title = 'Select an item', onClose}: SelectHeaderProps) => {
  return (
    <div className={styles.Header}>
      <Heading id={id} as="h1" className={styles.Title}>
        {title}
      </Heading>
      <IconButton icon={XIcon} aria-label="Close" variant="invisible" onClick={onClose} />
    </div>
  )
}
